import { Home } from 'lucide-react';

import type { NavItem } from '@/components/layout/nav';

/**
 * Sidebar entries this feature owns. `components/layout/nav.ts` collects every
 * feature's `nav` export, so later features (P1-T5's Organizations, …) append
 * items here without touching the layout or the shell.
 */
export const nav: NavItem[] = [{ to: '/', label: 'Home', icon: Home, match: 'exact' }];
